module.exports = __webpack_public_path__ + "static/media/education-object-3-0-2.b7158a1d.svg";